{
  "name": "tunify",
  "version": "5.08.01",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host=127.0.0.1",
    "start-local": "ng serve --configuration=local",
    "start-test": "ng serve --configuration=test",
    "start-prod": "ng serve --configuration=production",
    "build-for-test": "ng build --configuration=test-v5 --output-path=dist/test/v5/ --base-href=/",
    "build-for-prod": "ng build --configuration=production --output-path=dist/prod/v5/ --base-href=/",
    "cloudflare-build-for-test": "ng build --configuration=test-v5 --output-path=dist/ --base-href=/",
    "cloudflare-build-for-prod": "ng build --configuration=production --output-path=dist/ --base-href=/",
    "docker-build-for-test": "ng build --configuration=test-v5 --output-path=dist/ --base-href=/",
    "docker-build-for-prod": "ng build --configuration=production --output-path=dist/ --base-href=/",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "upload-source-map-to-datadog": "export DATADOG_API_KEY=c338a70c9461beef70dcd70fdd151145 && export DATADOG_SITE=datadoghq.eu && datadog-ci sourcemaps upload dist/prod/v5/browser/ --service=tunify-html-player --release-version=$npm_package_version --minified-path-prefix=https://player.tunify.com/"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.0.5",
    "@angular/cdk": "20.0.4",
    "@angular/common": "20.0.5",
    "@angular/compiler": "20.0.5",
    "@angular/compiler-cli": "20.0.5",
    "@angular/core": "20.0.5",
    "@angular/fire": "20.0.1",
    "@angular/forms": "20.0.5",
    "@angular/material": "20.0.4",
    "@angular/platform-browser": "20.0.5",
    "@angular/platform-browser-dynamic": "20.0.5",
    "@angular/router": "20.0.5",
    "@angular/service-worker": "20.0.5",
    "@applandstream/ua-parser-js": "2.0.0-beta.2",
    "@datadog/browser-rum": "6.12.3",
    "@fortawesome/angular-fontawesome": "^2.0.1",
    "@fortawesome/fontawesome-svg-core": "6.6.0",
    "@fortawesome/free-regular-svg-icons": "6.6.0",
    "@fortawesome/free-solid-svg-icons": "6.6.0",
    "@ngx-translate/core": "16.0.4",
    "@ngx-translate/http-loader": "16.0.1",
    "@rebolon/json-reviver": "0.0.9",
    "@supy-io/ngx-intercom": "14.2.12",
    "@todesktop/client-comm-server": "0.56.0",
    "@todesktop/client-core": "1.20.0",
    "@uiowa/digit-only": "4.0.0",
    "ably": "2.10.0",
    "custom-protocol-check": "1.4.0",
    "deepmerge-ts": "7.1.5",
    "dompurify": "^2.5.8",
    "moment": "2.30.1",
    "ngx-device-detector": "^10.0.2",
    "ngx-translate-multi-http-loader": "20.0.0",
    "ngx-webstorage-service": "5.0.0",
    "rxjs": "7.8.2",
    "sass": "1.89.2",
    "tslib": "2.7.0",
    "uuid": "11.1.0",
    "web-animations-js": "2.3.2",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "20.0.4",
    "@angular/cli": "20.0.4",
    "@angular/language-service": "20.0.5",
    "@datadog/datadog-ci": "3.11.0",
    "@types/jasmine": "^5.1.4",
    "@types/node": "22.7.4",
    "@typescript-eslint/eslint-plugin": "8.8.0",
    "@typescript-eslint/parser": "8.8.0",
    "angular-in-memory-web-api": "^0.20.0",
    "eslint": "9.12.0",
    "jasmine-core": "5.8.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "ts-node": "10.9.2",
    "typescript": "5.8.3"
  },
  "overrides": {
    "@uiowa/digit-only": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core"
    }
  }
}
